import { Component } from '@angular/core';

@Component({
  selector: 'app-filter-minimal',
  templateUrl: './filter-minimal.component.html',
  styleUrls: ['./filter-minimal.component.scss']
})
export class FilterMinimalComponent {

}
